import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

const TermsOfService = () => {
  return (
    <>
      <SEOHead
        title="Terms of Service"
        description="ParadoxEdge terms of service. Read the terms and conditions for using our executive coaching and leadership development services."
        canonicalUrl="/terms"
        keywords="terms of service, terms and conditions, legal terms"
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <main className="container-mobile py-12 sm:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-primary text-2xl sm:text-3xl font-bold mb-8">Terms of Service</h1>
            
            <div className="space-y-6 text-foreground/80">
              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">1. Agreement to Terms</h2>
                <p className="text-base leading-relaxed">
                  By accessing and using Paradox Edge's services, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our services. These terms constitute a legally binding agreement between you and Paradox Edge.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">2. Services Description</h2>
                <p className="text-base leading-relaxed">
                  Paradox Edge provides leadership development and coaching services. Our services include, but are not limited to, individual coaching, group training, and organizational consulting. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">3. User Responsibilities</h2>
                <p className="text-base leading-relaxed">
                  Users agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for maintaining the confidentiality of your account credentials.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">4. Intellectual Property</h2>
                <p className="text-base leading-relaxed">
                  All content, materials, and methodologies provided through our services are protected by intellectual property rights and remain the property of Paradox Edge. You may not modify, reproduce, distribute, or create derivative works based on our content without express written consent.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">5. Payment Terms</h2>
                <p className="text-base leading-relaxed">
                  Payment terms will be specified in your service agreement. All fees are non-refundable unless otherwise specified in writing. We reserve the right to modify our pricing with notice to you.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">6. Limitation of Liability</h2>
                <p className="text-base leading-relaxed">
                  Paradox Edge shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services. Our total liability shall not exceed the amounts paid by you for the services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">7. Governing Law</h2>
                <p className="text-base leading-relaxed">
                  These terms shall be governed by and construed in accordance with the laws of the State of Arizona, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Maricopa County, Arizona.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">8. Changes to Terms</h2>
                <p className="text-base leading-relaxed">
                  We reserve the right to modify these terms at any time. We will notify you of any material changes by posting the new terms on our website. Your continued use of the services constitutes acceptance of the modified terms.
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfService;
